export const InteractiveElementType = {
  SIGN_IN: 'sign_in',
};

export const AuthPromptType = {
  REQUIRED: 'auth_required',
  SUGGESTED: 'auth_suggested',
};

export const InteractiveAction = {
  APPLE_SIGN_IN: 'appleSignIn',
  GOOGLE_SIGN_IN: 'googleSignIn',
};
const ENABLE_APPLE_SIGN_IN = process.env.REACT_APP_ENABLE_APPLE_SIGN_IN === 'true';

const isApplePrompt = (message) => {
  const systemData = message?.system_data || {};
  return (
    message?.offerAppleSignIn === true ||
    message?.message_type === 'apple_signin_prompt' ||
    systemData?.prompt_type === 'apple_signin'
  );
};

const isAuthPrompt = (message) => {
  const systemData = message?.system_data || {};
  const promptType = systemData?.prompt_type || message?.message_type;
  const hasAuthAction =
    Array.isArray(message?.actions) &&
    message.actions.some((action) => (
      ['apple_signin', 'google_signin', 'auth_prompt'].includes(action)
    ));

  return (
    promptType === AuthPromptType.REQUIRED ||
    promptType === AuthPromptType.SUGGESTED ||
    promptType === 'auth_prompt' ||
    promptType === 'auth_required' ||
    promptType === 'auth_suggested' ||
    hasAuthAction
  );
};

const normalizeInteractiveElement = (element) => {
  if (!element || typeof element !== 'object' || Array.isArray(element)) return null;

  const type = element.type || InteractiveElementType.SIGN_IN;
  const provider = element.provider || 'google';
  const action =
    element.action ||
    (provider === 'google' ? InteractiveAction.GOOGLE_SIGN_IN : InteractiveAction.APPLE_SIGN_IN);
  const label =
    element.label ||
    (provider === 'google' ? 'Sign in with Google' : 'Sign in with Apple');

  return {
    type,
    provider,
    action,
    label,
    roleRequired: element.roleRequired || element.role || 'guest'
  };
};

export const buildMessageBubble = (message) => {
  const normalizedTimestamp = message?.timestamp ? new Date(message.timestamp) : new Date();

  const interactiveElements = [];

  if (ENABLE_APPLE_SIGN_IN && isApplePrompt(message)) {
    interactiveElements.push(
      normalizeInteractiveElement({
        type: InteractiveElementType.SIGN_IN,
        provider: 'apple',
        action: InteractiveAction.APPLE_SIGN_IN,
        label: 'Sign in with Apple',
        roleRequired: 'guest'
      })
    );
  }

  if (isAuthPrompt(message)) {
    const actions = Array.isArray(message?.actions) ? message.actions : [];
    const shouldIncludeApple =
      ENABLE_APPLE_SIGN_IN && (actions.length === 0 || actions.includes('apple_signin'));
    const shouldIncludeGoogle = actions.length === 0 || actions.includes('google_signin');

    if (shouldIncludeApple) {
      interactiveElements.push(
        normalizeInteractiveElement({
          type: InteractiveElementType.SIGN_IN,
          provider: 'apple',
          action: InteractiveAction.APPLE_SIGN_IN,
          label: 'Sign in with Apple',
          roleRequired: 'guest'
        })
      );
    }

    if (shouldIncludeGoogle) {
      interactiveElements.push(
        normalizeInteractiveElement({
          type: InteractiveElementType.SIGN_IN,
          provider: 'google',
          action: InteractiveAction.GOOGLE_SIGN_IN,
          label: 'Sign in with Google',
          roleRequired: 'guest'
        })
      );
    }
  }

  // New API: messages may carry explicit interactive elements
  if (Array.isArray(message?.interactive_elements)) {
    message.interactive_elements.forEach((el) => {
      const normalized = normalizeInteractiveElement(el);
      if (normalized && (normalized.provider !== 'apple' || ENABLE_APPLE_SIGN_IN)) {
        interactiveElements.push(normalized);
      }
    });
  }

  return {
    ...message,
    timestamp: normalizedTimestamp,
    interactiveElements
  };
};
